var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingBillPaymentInvoiceReceiptSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    stroke: "#000000",
    strokeWidth: 0.72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.1,0.6c-0.5-0.4-1-0.6-1.6-0.6v0h-16C4.7,0,4,0.7,4,1.5V19H1.5C0.7,19,0,19.7,0,20.5v1C0,22.9,1.1,24,2.5,24h15 c0.2,0,0.3,0,0.4,0c1.2-0.2,2.1-1.3,2.1-2.6V9h2.5C23.3,9,24,8.3,24,7.5v-5C24,1.8,23.7,1.1,23.1,0.6z M2.5,23 C1.7,23,1,22.3,1,21.5v-1C1,20.2,1.2,20,1.5,20h13c0.3,0,0.5,0.2,0.5,0.5v1c0,0.5,0.2,1.1,0.5,1.5H2.5z M19,2.6v18.8 c0,0.8-0.5,1.5-1.2,1.6c-0.1,0-0.2,0-0.3,0h0c-0.3,0-0.7-0.1-0.9-0.4c-0.3-0.3-0.5-0.7-0.5-1.1v-1c0-0.8-0.7-1.5-1.5-1.5H5V1.5 C5,1.2,5.2,1,5.5,1h14C19.2,1.4,19,2,19,2.6z M23,7.5C23,7.8,22.8,8,22.5,8H20V2.6c0-0.8,0.5-1.5,1.2-1.6c0.5-0.1,0.9,0,1.2,0.3 C22.8,1.6,23,2.1,23,2.5V7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,14c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5-0.2,0.5-0.5S17.8,12,17.5,12H17v-0.5c0-0.3-0.2-0.5-0.5-0.5 S16,11.2,16,11.5v0.6c-0.6,0.2-1,0.8-1,1.4c0,0.8,0.7,1.5,1.5,1.5c0.3,0,0.5,0.2,0.5,0.5S16.8,16,16.5,16h-1 c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5H16v0.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-0.6c0.6-0.2,1-0.8,1-1.4 C18,14.7,17.3,14,16.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,5C7.2,5,7,4.8,7,4.5S7.2,4,7.5,4h1C8.8,4,9,3.8,9,3.5S8.8,3,8.5,3H8V2.5C8,2.2,7.8,2,7.5,2S7,2.2,7,2.5v0.6 C6.4,3.3,6,3.8,6,4.5C6,5.3,6.7,6,7.5,6C7.8,6,8,6.2,8,6.5S7.8,7,7.5,7h-1C6.2,7,6,7.2,6,7.5S6.2,8,6.5,8H7v0.5C7,8.8,7.2,9,7.5,9 S8,8.8,8,8.5V7.9c0.6-0.2,1-0.8,1-1.4C9,5.7,8.3,5,7.5,5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,3h-7C10.2,3,10,2.8,10,2.5S10.2,2,10.5,2h7C17.8,2,18,2.2,18,2.5S17.8,3,17.5,3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5h-4C10.2,5,10,4.8,10,4.5S10.2,4,10.5,4h4C14.8,4,15,4.2,15,4.5S14.8,5,14.5,5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,7h-4C10.2,7,10,6.8,10,6.5S10.2,6,10.5,6h4C14.8,6,15,6.2,15,6.5S14.8,7,14.5,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,9h-7C10.2,9,10,8.8,10,8.5S10.2,8,10.5,8h7C17.8,8,18,8.2,18,8.5S17.8,9,17.5,9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,12h-7C6.2,12,6,11.8,6,11.5S6.2,11,6.5,11h7c0.3,0,0.5,0.2,0.5,0.5S13.8,12,13.5,12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,14h-4C9.2,14,9,13.8,9,13.5S9.2,13,9.5,13h4c0.3,0,0.5,0.2,0.5,0.5S13.8,14,13.5,14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16h-4C9.2,16,9,15.8,9,15.5S9.2,15,9.5,15h4c0.3,0,0.5,0.2,0.5,0.5S13.8,16,13.5,16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,18h-7C6.2,18,6,17.8,6,17.5S6.2,17,6.5,17h7c0.3,0,0.5,0.2,0.5,0.5S13.8,18,13.5,18z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingBillPaymentInvoiceReceiptSvgrepoCom);
export default __webpack_public_path__ + "static/media/marketing-bill-payment-invoice-receipt-svgrepo-com.034d2831e1411b6fde04747526ccf5b9.svg";
export { ForwardRef as ReactComponent };